import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RestaurantsNavigation.css';
import React, { memo, useState } from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as IconChevronDown } from "../../resources/icons/IconChevronDown.svg";
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import Select from 'react-select';
import { BASE_SINGLE_SELECT_PROPS } from '../../utils/constants';
import { isNil, isNotNil } from '../../utils/IsNil';
import getListing from '../../utils/getListing';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import RouterLink from '../atoms/RouterLink';
import { replacerPlusAndAmpersandForValidQueryString } from '../../utils/replacerPlusAndAmpersandForValidQueryString';
var reactSelectSingleUiSettings = _objectSpread(_objectSpread({}, BASE_SINGLE_SELECT_PROPS), {}, {
  styles: _objectSpread(_objectSpread({}, BASE_SINGLE_SELECT_PROPS.styles), {}, {
    option: function option(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        ".contrast &, .dark &": {
          ":hover": {
            backgroundColor: "#8080806e"
          },
          ":active": {
            backgroundColor: "#8080806e"
          },
          backgroundColor: state.isFocused ? "#8080806e" : state.isSelected ? "#808080" : base.backgroundColor,
          color: state.isSelected ? "#4D4D4D" : "black"
        }
      });
    }
  })
});
var RestaurantsNavigation = /*#__PURE__*/memo(function (_ref) {
  var params = _ref.params,
    fields = _ref.fields;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    selectedOptions = _React$useState4[0],
    setSelectedOptions = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    options = _React$useState6[0],
    setOptions = _React$useState6[1];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    cuisinesList = _useState2[0],
    setCuisinesList = _useState2[1];
  var types = "type:Restaurant";
  var algoliaIndexes = get(params, 'SearchIndex');
  var title = get(fields, "data.datasource.title.jss.value");
  var subTitle = get(fields, "data.datasource.text.jss.value");
  var facetName = get(fields, "data.datasource.fieldName.targetItem.fieldName.jss.value");
  var href = get(fields, "data.datasource.overviewLink.jss.value.href");
  var linktype = get(fields, "data.datasource.overviewLink.jss.value.linktype");
  var moduleDictionary = get(fields, 'data.moduleDictionary');
  var ctaButtonText = getDictionaryItem(moduleDictionary, 'ShowRestaurants');
  var selectNeighbourhoodPlaceholder = getDictionaryItem(moduleDictionary, 'SelectNeighbourhood');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var linkAnalyticsClick = function linkAnalyticsClick(textArray) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['linkClickAnalytics'], params), textArray);
  };
  var createNeighbourhoodNavigation = function createNeighbourhoodNavigation(hits) {
    var navigationObj = {};
    hits.forEach(function (hit) {
      return hit.location.forEach(function (currentLocation) {
        isNotNil(navigationObj[currentLocation]) ? navigationObj[currentLocation]++ : navigationObj[currentLocation] = 1;
      });
    });
    var navigationArray = Object.entries(navigationObj).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        name = _ref3[0],
        count = _ref3[1];
      return {
        name: name,
        count: count
      };
    });
    var options = Object.entries(navigationObj).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        name = _ref5[0];
      return {
        label: name,
        value: name
      };
    });
    setCuisinesList(navigationArray);
    setOptions(options);
  };
  var algoliaRequest = function algoliaRequest() {
    var itemFilters = {
      facetFilters: [types]
    };
    getListing(algoliaIndexes, itemFilters).then(function (response) {
      createNeighbourhoodNavigation(response.hits);
    }).catch(function (error) {
      console.log("error", error);
    });
  };
  React.useEffect(function () {
    algoliaRequest();
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource) || isNil(facetName)) {
    console.info('RestaurantsNavigation component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [RestaurantsNavigation component is empty: please provide data source]");
    }
    return null;
  }
  var goToUrl = function goToUrl() {
    window.location.href = "".concat(href, "?").concat(facetName, "=").concat(replacerPlusAndAmpersandForValidQueryString(selectedOptions.value));
  };
  var isRestaurantsNavigationButtonEnabled = function isRestaurantsNavigationButtonEnabled() {
    return selectedOptions !== null;
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "subTitle"
  }, subTitle), /*#__PURE__*/React.createElement("div", {
    className: "restaurantsNavigationGridContainer"
  }, cuisinesList.map(function (el, index) {
    return /*#__PURE__*/React.createElement(RouterLink, {
      href: "".concat(href, "?").concat(facetName, "=").concat(replacerPlusAndAmpersandForValidQueryString(el.name)),
      linktype: linktype,
      className: "restaurantsNavigationItem",
      onClick: function onClick() {
        return linkAnalyticsClick([title, el.name]);
      },
      key: index
    }, /*#__PURE__*/React.createElement(IconChevronDown, {
      className: "icon"
    }), /*#__PURE__*/React.createElement("span", null, el.name), /*#__PURE__*/React.createElement("span", {
      className: "restaurantsNavigationCount"
    }, "(", el.count, ")"));
  })), /*#__PURE__*/React.createElement("div", {
    className: "restaurantsNavigationMobileView"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
    options: options,
    className: "react-custom-select",
    onChange: function onChange(el) {
      return setSelectedOptions(el);
    },
    placeholder: selectNeighbourhoodPlaceholder,
    value: selectedOptions
  })), /*#__PURE__*/React.createElement("button", {
    onClick: goToUrl,
    className: "btn btn-primary ".concat(isRestaurantsNavigationButtonEnabled() ? "" : "disabled"),
    disabled: !isRestaurantsNavigationButtonEnabled()
  }, ctaButtonText)));
});
var StyledWrapper = function StyledWrapper(_ref6) {
  var children = _ref6.children,
    rtl = _ref6.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c8mfi4";
var ltrStyles = "l1s4rdjc";
var rtlStyles = "rqon255";
export default RestaurantsNavigation;